import {Epic, ofType} from "redux-observable";
import {AppActions} from "../actions";
import {AppState} from "../AppState";
import {mergeMap} from "rxjs/operators";
import {of} from "rxjs";
import {
    USER_LOGGED_IN,
    WorkforceOneLoggedInAction,
} from "../actions/WorkforceOneLoginActions";
import {AllowSelectCompany, SelectCompany} from "../actions/WorkforceClinicAction";

const WorkforceOneUserAutoCompanySelectionEpic:  Epic<AppActions, AppActions, AppState> = (action$, states$) => {
    return action$.pipe(
        ofType(USER_LOGGED_IN),
        mergeMap((action: AppActions) => {
                const selectedLoggedInUser = action as WorkforceOneLoggedInAction;
                if(selectedLoggedInUser.payload.Portal.Clinic.length === 1) {
                    const portal = selectedLoggedInUser.payload.Portal.Clinic[0]
                    if (portal.ParticipationID || 0 > 0 && portal.Link?.length || 0 > 0) {
                      return of (SelectCompany(portal.ParticipationID || "", portal.Link || ""))
                    }
                    const allCompanies = selectedLoggedInUser.payload.Portal.Clinic[0].AssignedClientDetailsOfClinic
                    const companies = allCompanies.filter(item => !item.LocationID)
                    if (companies.length === 1) {
                      return of (SelectCompany(companies[0].ParticipationID, companies[0].Link))
                    }
                    if (allCompanies.length === 1) {
                      return of (SelectCompany(allCompanies[0].ParticipationID, allCompanies[0].Link))
                    }
                }
                return of(AllowSelectCompany());
            }
        )
    );
};
export default WorkforceOneUserAutoCompanySelectionEpic;
